import apiClient from './api';

class TagsManagementService {
  /**
   * 获取所有知识库
   */
  async getAllKnowledgeBases() {
    const response = await apiClient.get('/tags-management/knowledge-bases');
    return response.data.data || response.data;
  }

  /**
   * 根据知识库ID获取主题列表
   */
  async getTopicsByKbId(kbId) {
    const response = await apiClient.get(`/tags-management/topics/${kbId}`);
    return response.data.data || response.data;
  }

  /**
   * 获取主题名称查找表列表
   */
  async getTopicNameLookups() {
    const response = await apiClient.get('/tags-management/topic-name-lookups');
    return response.data.data || response.data;
  }

  /**
   * 获取主题名称查找表的层级结构
   */
  async getTopicNameLookupHierarchy() {
    const response = await apiClient.get('/tags-management/topic-name-lookup-hierarchy');
    return response.data.data || response.data;
  }

  /**
   * 获取标签列表
   */
  async getTags(params = {}) {
    // 定义分页限制常量，从环境变量读取，默认20
    const pageLimit = parseInt(process.env.REACT_APP_FETCH_LIMIT || process.env.FETCH_LIMIT || '20', 10);
    const { kbId, topicId, isPrivate, level1TopicId, level2TopicId, page = 1, limit = pageLimit } = params;
    
    const queryParams = new URLSearchParams();
    if (kbId) queryParams.append('kbId', kbId);
    if (topicId) queryParams.append('topicId', topicId);
    if (isPrivate !== undefined) queryParams.append('isPrivate', isPrivate.toString());
    if (level1TopicId) queryParams.append('level1TopicId', level1TopicId);
    if (level2TopicId) queryParams.append('level2TopicId', level2TopicId);
    queryParams.append('page', page.toString());
    queryParams.append('limit', limit.toString());
    
    const response = await apiClient.get(`/tags-management/tags?${queryParams.toString()}`);
    return response.data.data || response.data;
  }

  /**
   * 创建标签
   */
  async createTag(data) {
    // 验证标签名称长度，数据库字段限制为50个字符
    if (data.name && data.name.length > 50) {
      throw new Error('Tag name is too long, please use 50 characters or less');
    }
    
    const response = await apiClient.post('/tags-management/tags', data);
    return response.data.data || response.data;
  }

  /**
   * 更新标签
   */
  async updateTag(ttslId, data) {
    const response = await apiClient.put(`/tags-management/tags/${ttslId}`, data);
    return response.data.data || response.data;
  }

  /**
   * 删除标签
   */
  async deleteTag(ttslId) {
    const response = await apiClient.delete(`/tags-management/tags/${ttslId}`);
    return response.data.data || response.data;
  }

  /**
   * 批量删除标签
   */
  async batchDeleteTags(ttslIds) {
    const response = await apiClient.delete('/tags-management/tags/batch', {
      data: { ttslIds }
    });
    return response.data.data || response.data;
  }

  /**
   * 根据tnl_id获取对应的kb_topic记录
   */
  async getKbTopicByTnlId(tnlId) {
    const response = await apiClient.get(`/tags-management/kb-topic/${tnlId}`);
    return response.data.data || response.data;
  }
}

export const tagsManagementService = new TagsManagementService(); 